module.exports = __webpack_public_path__ + "img/electrical_offline.e42ec5ae.png";